/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  VERIFY_OTP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.BuyInsurancePage.verify-otp',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'VERIFY_OTP' },
      },
    },
    VERIFY_OTP: {
      invoke: {
        id: 'verifyOTP',
        src: 'verifyOTP',
        onDone: {
          target: 'VERIFY_OTP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'VERIFY_OTP_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    VERIFY_OTP_SUCCESS: {
      type: 'final',
    },
    VERIFY_OTP_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
